export const updateCheckoutItemPendingAction = (state) => {
	state.orderSummary.isLoading = true;
};
